export const LOGO = {
  DARK: "glacier_logo.png",
  LIGHT: "glacier_logo.png",
}
